

import { useState, useEffect, useRef } from "react";
import MKTypography from "components/MKTypography"; 
import Icon from "@mui/material/Icon";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Container from "@mui/material/Container";
import MKButton from "components/MKButton";
import MKBox from "components/MKBox";
import MKInput from "components/MKInput";
import Modal from "@mui/material/Modal";
import Slide from "@mui/material/Slide";
import Divider from "@mui/material/Divider";
import MKAlert from "components/MKAlert";
import MKAvatar from "components/MKAvatar"; 
import defaultIcon from 'assets/images/appkey-red-circle-100.png' ;
import Resizer from "react-image-file-resizer";
import {startAuthentication} from '@simplewebauthn/browser';
import Dropdowns from "components/AppKey/Dropdowns";
import { useNavigate } from "react-router-dom"
import { appAuth } from "../../contexts/AppContext"
import { useAuth } from "../../contexts/AuthContext"
 

export default function AppSetting({app}) { 

    const navigate = useNavigate() 
    const { setLoadingSuccessData, updateApp, deleteApp, resetApp , allApps, exportAppDatabase, updateAppIcon} = appAuth()
    const {verify, verifyComplete, uploadAvatar, uploadFileToBlob, setLoading} = useAuth()
    const [errorMessage, setErrorMessage] = useState("");
    const [appState, setAppState] = useState({showDelete:false, showClearAppData:false})
    const [appData, setAppData] = useState(app)
    const [appIcon, setAppIcon] = useState({})
    const toggleModalDelete = () =>  setAppState({...appState, ["showDelete"]: !appState.showDelete}) 
    const fileInput = useRef(null)
    const toggleModalClearData  = () =>  setAppState({...appState, ["showClearAppData"]: !appState.showClearAppData})
    const [isUdpated, setIsUpdated] = useState(false)


    useEffect(() => { 
        setAppData(app)
        setAppIcon(app.icon || {})
        //console.log("AppSetting app  ", app.name)  
            
    }, [])



    const handleAvatarClick = () => {
        if (!appIcon.loading ) fileInput.current.click()
    }

    const onImageChange = (event) => {
        if (event.target.files && event.target.files[0]) {
            setIsUpdated(true)
            let img = event.target.files[0];
            console.log("onImageChange image ", img)
            setAppIcon({
                ...appIcon,
                ['file']: img, 
                ['filePath'] : URL.createObjectURL(img)
            }) 

            localStorage.setItem('isUpdatingUser', "true");  
        }
    };

    const verifyPasskey = async () => {
        try { 
            
            let challenge = await verify();
            if(challenge.error) {
                return;
            }

            let asseResp = await startAuthentication({ optionsJSON: challenge });
            let authn = await verifyComplete(asseResp);
            if (authn.error) {
                setErrorMessage(` ${authn.error.message}.`)
                return false
            }

            return true;
        } catch (error) {
            return false;
        }
    }
    
    const updateAppHandler = async () =>{
       // console.log("app name ", appData.name) 
        if(appIcon.loading) return

        let checked = allApps.filter(app => app.name.toLowerCase() == appData.name.toLowerCase())[0];
        if (checked && checked.appId != appData.appId){  
            setErrorMessage(`App name '${appData.name}' already exists.`)
        }  
        else {
            let app = allApps.filter(app => app.appId == appData.appId)[0];
            if(app.name != appData.name ) updateAppData(appData.name, "name")
            if(app.desc != appData.desc) updateAppData(appData.desc, "desc")
        } 

        if(!appIcon.file) {
             localStorage.setItem('isUpdatingUser', "false");  
             return;
        }

        setAppIcon({
            ...appIcon,
            ['loading'] : true
        })

        let result = await uploadAvatar(appIcon.file.name, appData.appId)
        console.log("updateAppHandler result ", result)
        if(!result || !result.writeUrl) return

        setLoading(true)

        let paths = {
            appId: appData.appId,
            pathOrigin: result.path,
            pathSmall: result.pathSmall,
            pathMedium: result.pathMedium,
            pathLarge: result.pathLarge
        };

        let origin = await convertFileToArrayBuffer(appIcon.file);
        let upload = await uploadFileToBlob(result.writeUrl, origin, appIcon.file.type);
        if(upload.error){
            setLoading(false)
            return;
        }
        if(upload && result.writeUrlSmall){
          let smallFile = await resizeFile(appIcon.file, 300, "file");
          let small = await convertFileToArrayBuffer(smallFile);
          await uploadFileToBlob(result.writeUrlSmall, small);

          let mediumFile = await resizeFile(appIcon.file, 600, "file");
          let medium = await convertFileToArrayBuffer(mediumFile);
          await uploadFileToBlob(result.writeUrlMedium, medium);

          let largeFile = await resizeFile(appIcon.file, 900, "file");
          let large = await convertFileToArrayBuffer(largeFile);
          let upload = await uploadFileToBlob(result.writeUrlLarge, large);
          console.log("updateProfileHandler upload ", upload)
        }
        setIsUpdated(false)
        setAppIcon({
            ...appIcon,
            ['loading'] : false
        })
          
        let uploaded = await updateAppIcon(paths)
        if(uploaded){
            setAppIcon(uploaded.icon || {})
            app.icon = uploaded.icon
        }
        setLoading(false)
          
        localStorage.setItem('isUpdatingUser', "false");  

    }


  const resizeFile = (file, size, outputType) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        size,
        size,
        "JPEG",
        100,
        0,
        (uri) => {
          resolve(uri);
        },
        outputType || "base64"
      );
  });

  const convertFileToArrayBuffer = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsArrayBuffer(file);
    });
  };



    const onChangeValue = (evt)=> {
        setAppData({
            ...appData,
            [evt.target.name]: evt.target.value
        })

        setIsUpdated(true)
        localStorage.setItem('isUpdatingUser', "true");  
    } 

    const exportAppData = async () => {

        let passedVerify = await verifyPasskey();
        if(!passedVerify) return;
        
        let result = await exportAppDatabase(app)
    }

    const updateAppData = async (value, option) => { 

        let result = await updateApp(app.appId, option, value)

        console.log("updateAppData " , result)
        if(result.error) setErrorMessage(` ${result.error.message}.`)
        //localStorage.setItem('isUpdatingUser', "false");  
    }


    const deleteAppHandler = async () => {
        toggleModalDelete() 
        let passedVerify = await verifyPasskey();
        if(!passedVerify) return;

        let result = await deleteApp(app.appId);
        if(result === true) {
            navigate("/apps")
        }
        else setErrorMessage(` ${result.error.message}.`)
    }


    const clearAppDataHandler = async () => {
        toggleModalClearData()

        let passedVerify = await verifyPasskey();
        if(!passedVerify) return;

        let result = await resetApp(app.appId);
        if(result.error) setErrorMessage(` ${result.error.message}.`)
        if(result) setLoadingSuccessData({message:"Your App has been cleared."})
    }


    return( 
        <MKBox p={2}>

            {errorMessage != "" && <MKAlert color="error" dismissible>{errorMessage}</MKAlert>}
           
            <MKTypography variant="h5">Application Settings</MKTypography>
            
            <Container >
                
                <Grid container spacing={1} mt={2} pb={5}>
                    <Grid item xs={12} md={5} lg={5}>
                        <Stack spacing={3}>
                            <Grid container mt={2} pb={5}>
                                <Grid item xs={12} md={5} lg={5}>
                                     <MKBox pt={4} display="inline-block"  onClick={handleAvatarClick}  sx={{ cursor: "pointer" }}>  
                                    
                                        <MKAvatar bgColor="light" src={appIcon && appIcon.filePath ? appIcon.filePath : 
                                        appIcon && appIcon.urlMedium ? appIcon.urlMedium : 
                                        defaultIcon} alt="Avatar" size="xxl" /> 

                                        {appIcon.loading ? <MKBox px={4} ><div className="dotloader" ></div> </MKBox> :
                                        <MKBox mt={-3} mr={-5}>
                                            <MKButton variant="text" color="info" iconOnly> <Icon>edit</Icon> </MKButton>
                                        </MKBox>
                                        }
                                    
                                        <input type="file" id="wizard-picture" accept="image/png, image/jpeg"  hidden ref={fileInput} onChange={onImageChange}/>
                                    
                                    </MKBox>
                                    <MKBox  sx={{ my: 2 }} justifyContent="left" >
                                        <MKButton variant="gradient" color="primary" disabled={!isUdpated} onClick={updateAppHandler}>
                                            Save
                                        </MKButton>
                                    </MKBox>
                                </Grid>
                                <Grid item xs={12} md={5} lg={5}>
                        
                                    <MKBox component="section" display="flex">  
                                        <MKInput variant="standard" label="App ID" disabled value={app.displayAppId}  /> 
                                        
                                        <MKButton color="white" onClick={() => {navigator.clipboard.writeText(app.displayAppId)}}>
                                            <Icon fontSize="large">copy</Icon>
                                        </MKButton>
                                        
                                    </MKBox>
                                    
                                    <MKInput variant="standard" inputProps={{ maxLength: 50 }} label="App Name" id="appName" name='name' defaultValue={app.name} onChange={onChangeValue} required fullWidth  />

                                    <MKInput variant="standard" multiline fullWidth rows={5} inputProps={{ maxLength: 250 }} label="App Description" id="appDesc" name='desc' defaultValue={app.desc} onChange={onChangeValue}  />

                                   
                                </Grid>
                        </Grid>
                            <MKTypography variant="h6" color="text">
                                RESET APP DATABASE 
                            </MKTypography>
                            <MKTypography variant="body2" color="text"> 
                                This will clear your App data from AppKey Portal
                            </MKTypography>
                            <MKBox  sx={{ my: 2 }} justifyContent="left" >
                                <MKButton variant="gradient" color="error" onClick={toggleModalClearData}>
                                    clear
                                </MKButton>
                            </MKBox>

                        </Stack>
                    </Grid>

                    <Grid item xs={12} md={2} lg={2}>

                    </Grid>

                    <Grid item xs={12} md={5} lg={5} >
                        <Stack spacing={3}>

                            <MKTypography variant="h6" color="text">
                                EXPORT APP DATABASE 
                            </MKTypography>
                            <MKTypography variant="body2" color="text"> 
                                This will export your App data from AppKey Portal
                            </MKTypography>
                            <MKBox  sx={{ my: 2 }} justifyContent="left" >
                                <MKButton variant="gradient" color="primary" onClick={exportAppData}>
                                    export
                                </MKButton>
                            </MKBox>

                            <MKBox alignItems="center" justifyContent="left" display="flex" >
                                <MKTypography variant="h6" color="text">
                                    APP STATUS:
                                </MKTypography>

                                <Dropdowns items={["ACTIVE",  "INACTIVE"]} defaultValue = { app.status.toUpperCase()}  onChange={(val) => { 
                                    updateAppData(val.toLowerCase(), "status")
                                }} />

                                

                            </MKBox>

                            <MKTypography variant="h6" color="text">
                                DELETE APP
                            </MKTypography>
                            <MKTypography variant="body2" color="text"> 
                                This will delete your App entirely from AppKey Portal
                            </MKTypography>
                            <MKBox  sx={{ my: 2 }} justifyContent="left" >
                                <MKButton variant="gradient" color="error" onClick={toggleModalDelete}>
                                    delete
                                </MKButton>
                            </MKBox>

                        </Stack>
                    </Grid>

                </Grid>
            </Container>



            <Modal open={appState.showClearAppData} onClose={toggleModalClearData} sx={{ display: "grid", placeItems: "center" }}>
                <Slide direction="down" in={appState.showClearAppData} timeout={500}>
                    <MKBox
                    position="relative"
                    sx={{ maxWidth: 'md' }}
                    display="flex"
                    flexDirection="column"
                    borderRadius="xl"
                    bgColor="white"
                    shadow="xl"
                    >
                    <MKBox display="flex" alignItems="center" justifyContent="space-between" p={2}>
                        <MKTypography variant="h5">Are you sure to clear this app data?</MKTypography> 
                    </MKBox>
                    <Divider sx={{ my: 0 }} />
                    <MKBox p={2}>
                        <MKTypography variant="body">This transaction can't undo.</MKTypography>
                    </MKBox>
                    <Divider sx={{ my: 0 }} />
                    <MKBox display="flex" justifyContent="space-between" p={1.5}>
                        <MKButton variant="gradient" color="dark" onClick={toggleModalClearData}>
                        cancel
                        </MKButton>
                        <MKButton variant="gradient" color="primary" onClick={clearAppDataHandler}>
                        Submit
                        </MKButton>
                    </MKBox>
                    </MKBox>
                </Slide>
            </Modal>
                

            <Modal open={appState.showDelete} onClose={toggleModalDelete} sx={{ display: "grid", placeItems: "center" }}>
                <Slide direction="down" in={appState.showDelete} timeout={300}>
                    <MKBox
                    position="relative"
                    sx={{ maxWidth: 'md' }}
                    display="flex"
                    flexDirection="column"
                    borderRadius="xl"
                    bgColor="white"
                    shadow="xl"
                    >
                    <MKBox display="flex" alignItems="center" justifyContent="space-between" p={2}>
                        <MKTypography variant="h5">Are you sure to delete this app?</MKTypography> 
                    </MKBox>
                    <Divider sx={{ my: 0 }} />
                    <MKBox p={2}>
                        <MKTypography variant="body">This transaction can't undo.</MKTypography>
                    </MKBox>
                    <Divider sx={{ my: 0 }} />
                    <MKBox display="flex" justifyContent="space-between" p={1.5}>
                        <MKButton variant="gradient" color="dark" onClick={toggleModalDelete}>
                        cancel
                        </MKButton>
                        <MKButton variant="gradient" color="primary" onClick={deleteAppHandler}>
                        Submit
                        </MKButton>
                    </MKBox>
                    </MKBox>
                </Slide>
            </Modal>


        </MKBox> 



       
    )
}
